import { placeholderAvatar } from '../placeholderAvatar'
import useOrganizationTheme from './useOrganizationColors'

export default function (text) {
  const { primary, primaryText } = useOrganizationTheme()
  return placeholderAvatar(text, primary, primaryText).toString()
}
